import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=fa8bf2ae&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=fa8bf2ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8bf2ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa8bf2ae')) {
      api.createRecord('fa8bf2ae', component.options)
    } else {
      api.reload('fa8bf2ae', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=fa8bf2ae&scoped=true&", function () {
      api.rerender('fa8bf2ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UHtvHmy1h2xy/JS/comp/GuestBox.vue"
export default component.exports